// import React, { useEffect, useState } from 'react';
// import Select from 'react-select';
// import { useTranslation } from 'react-i18next';

// import Loading from '@components/Shared/Loader/Loading';
// import { Card, CardFooter, CardHeader } from '@components/card/card';

// import { useAppDispatch, useAppSelector } from '@store/hooks';
// import { initReport, getReportPagedData, selectReport, setReportRequest } from '@store/DynamicSlice/reportTableSlice';

// import ReportExportExcelModal, { type ExportColumn } from '@Helper/ReportPaged/ReportExportExcelModal';
// import ReportPagination from '@Helper/ReportPaged/ReportPagination';

// import useGetOperatingUnitWithPermission from '@hooks/NTX/Organization/useGetOperatingUnitWithPermission';
// import useGetSuppliersList from '@hooks/NTX/Peoples/useGetSuppliersList';

// /** =========================
//  * REQUEST SHAPE
//  * ========================= */
// type ApSuppliersTotalBalancesReq = {
//   pageIndex?: number;
//   pageSize?: number;
//   aS_OF_DATE?: string | null;
//   supplieR_ID?: string | null;
//   organizatioN_ID?: string | null;
// };

// /** =========================
//  * RESPONSE SHAPE (Array items)
//  * ========================= */
// type RowDto = {
//   supplieR_NAME: string | null;
//   vaT_CODE: string | null;
//   totaL_PURCHASES: number | null;
//   totaL_PAYMENTS_ADJUSTED: number | null;
//   neT_BALANCE: number | null;
//   status: string | null;
// };

// const REPORT_KEY = 'RPT_ApSuppliersTotalBalances';
// const ENDPOINT = 'FinReports/GetApSuppliersTotalBalances';

// const safe = (v: any, fallback = '—') => (v === null || v === undefined || v === '' ? fallback : String(v));

// const formatNumber = (num: number | null | undefined, digits: number = 2) => {
//   if (num === null || num === undefined) return '0.00';
//   return new Intl.NumberFormat('en-US', { minimumFractionDigits: digits, maximumFractionDigits: digits }).format(
//     num || 0
//   );
// };

// const isoOrNull = (d: any) => {
//   if (!d) return null;
//   if (typeof d === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(d)) return `${d}T00:00:00.000Z`;
//   if (d instanceof Date) return d.toISOString();
//   return null;
// };

// const cleanNulls = <T extends Record<string, any>>(obj: T): Partial<T> => {
//   const out: any = {};
//   for (const [k, v] of Object.entries(obj)) {
//     if (v === null || v === undefined || v === '') continue;
//     out[k] = v;
//   }
//   return out;
// };

// const getOptId = (opt: any): string | null => {
//   const v = opt?.value ?? opt?.id ?? opt?.ID ?? opt?.key ?? null;
//   return v ? String(v) : null;
// };

// const ApSuppliersTotalBalances_Paged: React.FC = () => {
//   const { t, i18n } = useTranslation();
//   const isAr = i18n.language !== 'en';

//   const dispatch = useAppDispatch();

//   // ===== Options Hooks
//   const branchHook = useGetOperatingUnitWithPermission() as any;
//   const OptionsBranches = branchHook?.OperatingUnitOptions ?? branchHook?.OptionsBranches ?? [];
//   const loadingBranches = branchHook?.loading ?? false;

//   const suppHook = useGetSuppliersList() as any;
//   const OptionsSuppliers = suppHook?.OptionSuppliers ?? suppHook?.OptionsSuppliers ?? suppHook?.options ?? [];
//   const loadingSuppliers = suppHook?.loading ?? false;

//   // ===== Filters State
//   const [branchFilter, setBranchFilter] = useState<any>(null);
//   const [supplierFilter, setSupplierFilter] = useState<any>(null);
//   const [asOfDate, setAsOfDate] = useState<any>(null);

//   const [showExport, setShowExport] = useState(false);

//   // ===== Report state
//   const report = useAppSelector(s => selectReport(s as any, REPORT_KEY));
//   const items = (report?.items ?? []) as RowDto[];
//   const meta = report?.meta ?? null;
//   const loading = report?.loading ?? false;
//   const error = report?.error ?? null;

//   useEffect(() => {
//     const initialRequest: ApSuppliersTotalBalancesReq = {
//       pageIndex: 0,
//       pageSize: 50
//     };

//     dispatch(
//       initReport({
//         reportKey: REPORT_KEY,
//         endpoint: ENDPOINT,
//         initialRequest
//       })
//     );
//   }, [dispatch]);

//   const applyFilters = () => {
//     const prevReq = (((report as any)?.request ?? {}) as ApSuppliersTotalBalancesReq) || {};

//     const nextReq: ApSuppliersTotalBalancesReq = {
//       ...prevReq,
//       pageIndex: 0,
//       pageSize: prevReq.pageSize ?? 50,
//       aS_OF_DATE: isoOrNull(asOfDate),
//       organizatioN_ID: getOptId(branchFilter),
//       supplieR_ID: getOptId(supplierFilter)
//     };

//     dispatch(setReportRequest({ reportKey: REPORT_KEY, request: cleanNulls(nextReq) as any }));
//     dispatch(getReportPagedData({ reportKey: REPORT_KEY }));
//   };

//   const clearFilters = () => {
//     setBranchFilter(null);
//     setSupplierFilter(null);
//     setAsOfDate(null);

//     const resetReq: ApSuppliersTotalBalancesReq = {
//       pageIndex: 0,
//       pageSize: 50
//     };

//     dispatch(setReportRequest({ reportKey: REPORT_KEY, request: resetReq as any }));
//   };

//   // Totals Cards
//   const TotalsCards = () => {
//     if (!meta) return null;

//     return (
//       <div className='row g-3 mb-4'>
//         {/* إجمالي المشتريات */}
//         <div className='col-lg-4 col-md-6'>
//           <Card className='bg-primary bg-opacity-10 border-0 shadow-sm h-100'>
//             <div className='card-body d-flex align-items-center'>
//               <div className='p-3 me-3'>
//                 <i className='fas fa-shopping-cart text-primary fa-xl'></i>
//               </div>
//               <div>
//                 <h6 className='text-primary fw-bold mb-1'>{isAr ? 'إجمالي المشتريات' : 'Grand Purchases'}</h6>
//                 <h4 className='mb-0 fw-bold'>{formatNumber(meta.granD_PURCHASES)}</h4>
//               </div>
//             </div>
//           </Card>
//         </div>

//         {/* إجمالي المدفوعات */}
//         <div className='col-lg-4 col-md-6'>
//           <Card className='bg-success bg-opacity-10 border-0 shadow-sm h-100'>
//             <div className='card-body d-flex align-items-center'>
//               <div className='p-3 me-3'>
//                 <i className='fas fa-money-check-alt text-success fa-xl'></i>
//               </div>
//               <div>
//                 <h6 className='text-success fw-bold mb-1'>{isAr ? 'إجمالي المدفوعات' : 'Grand Payments'}</h6>
//                 <h4 className='mb-0 fw-bold'>{formatNumber(meta.granD_PAYMENTS)}</h4>
//               </div>
//             </div>
//           </Card>
//         </div>

//         {/* إجمالي المديونية المستحقة */}
//         <div className='col-lg-4 col-md-6'>
//           <Card className='bg-danger bg-opacity-10 border-0 shadow-sm h-100'>
//             <div className='card-body d-flex align-items-center'>
//               <div className='p-3 me-3'>
//                 <i className='fas fa-file-invoice-dollar text-danger fa-xl'></i>
//               </div>
//               <div>
//                 <h6 className='text-danger fw-bold mb-1'>{isAr ? 'إجمالي المديونية المستحقة' : 'Total Outstanding Debt'}</h6>
//                 <h4 className='mb-0 fw-bold'>{formatNumber(meta.totaL_OUTSTANDING_DEBT)}</h4>
//               </div>
//             </div>
//           </Card>
//         </div>
//       </div>
//     );
//   };

//   const exportColumns: ExportColumn<RowDto>[] = [
//     { headerAr: 'المورد', headerEn: 'Supplier Name', value: r => r.supplieR_NAME || '' },
//     { headerAr: 'الرقم الضريبي', headerEn: 'VAT Code', value: r => r.vaT_CODE || '' },
//     { headerAr: 'إجمالي المشتريات', headerEn: 'Total Purchases', value: r => r.totaL_PURCHASES || 0 },
//     { headerAr: 'إجمالي المدفوعات', headerEn: 'Total Payments', value: r => r.totaL_PAYMENTS_ADJUSTED || 0 },
//     { headerAr: 'صافي الرصيد', headerEn: 'Net Balance', value: r => r.neT_BALANCE || 0 },
//     { headerAr: 'الحالة', headerEn: 'Status', value: r => r.status || '' },
//   ];

//   return (
//     <>
//       <CardHeader className='mb-3'>
//         <div className='row g-2 align-items-center mb-2'>
//           {/* Branch */}
//           <div className='col-lg-3'>
//             <div className='input-group'>
//               <span className='input-group-text fw-bold' title={isAr ? 'الفرع' : 'Branch'}>
//                 <i className='fas fa-store text-primary'></i>
//               </span>
//               <Select
//                 isLoading={loadingBranches}
//                 value={branchFilter}
//                 onChange={setBranchFilter}
//                 options={OptionsBranches}
//                 placeholder={isAr ? 'الفرع' : 'Branch'}
//                 isClearable
//                 isSearchable
//                 className='flex-grow-1'
//                 classNamePrefix='react-select'
//                 menuPortalTarget={document.body}
//                 styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
//               />
//             </div>
//           </div>

//           {/* Supplier */}
//           <div className='col-lg-4'>
//             <div className='input-group'>
//               <span className='input-group-text fw-bold' title={isAr ? 'المورد' : 'Supplier'}>
//                 <i className='fas fa-truck text-info'></i>
//               </span>
//               <Select
//                 isLoading={loadingSuppliers}
//                 value={supplierFilter}
//                 onChange={setSupplierFilter}
//                 options={OptionsSuppliers}
//                 placeholder={isAr ? 'المورد' : 'Supplier'}
//                 isClearable
//                 isSearchable
//                 className='flex-grow-1'
//                 classNamePrefix='react-select'
//                 menuPortalTarget={document.body}
//                 styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
//               />
//             </div>
//           </div>

//           {/* As of Date */}
//           <div className='col-lg-2'>
//             <div className='input-group'>
//               <span className='input-group-text fw-bold' title={isAr ? 'حتى تاريخ' : 'As Of Date'}>
//                 <i className='fas fa-calendar'></i>
//               </span>
//               <input
//                 type='date'
//                 className='form-control'
//                 value={asOfDate || ''}
//                 onChange={e => setAsOfDate(e.target.value)}
//                 placeholder={isAr ? 'حتى تاريخ' : 'As Of Date'}
//               />
//             </div>
//           </div>

//           {/* Buttons */}
//           <div className='col-lg-3 text-end'>
//             <button
//               className='btn btn-outline-secondary me-2'
//               type='button'
//               onClick={clearFilters}
//               title={t('ClearFilters')}
//             >
//               <i className='fas fa-times fa-fw'></i>
//             </button>
//             <button className='btn btn-theme me-2' type='button' onClick={applyFilters} title={t('ApplyFilters')}>
//               <i className='fas fa-filter fa-fw'></i>
//             </button>
//             <button
//               className='btn btn-outline-success'
//               type='button'
//               onClick={() => setShowExport(true)}
//               title={t('Export')}
//               disabled={loading || items.length === 0}
//             >
//               <i className='fas fa-file-excel fa-fw'></i>
//             </button>
//           </div>
//         </div>
//       </CardHeader>

//       <TotalsCards />

//       <Card className='mb-4'>
//         <Loading loading={loading} error={error}>
//           <div className='table-responsive' style={{ maxHeight: 'calc(100vh - 300px)', overflowY: 'auto' }}>
//             <table className='table table-hover table-bordered mb-0'>
//               <thead className='sticky-top align-middle' style={{ top: 0, zIndex: 10 }}>
//                 <tr className='bg-theme bg-opacity-25 text-center' style={{ backdropFilter: 'blur(20px)' }}>
//                   <th className='small py-3' style={{ minWidth: 250 }}>{isAr ? 'المورد' : 'Supplier'}</th>
//                   <th className='small py-3' style={{ minWidth: 150 }}>{isAr ? 'الرقم الضريبي' : 'VAT Code'}</th>
//                   <th className='small text-end py-3' style={{ minWidth: 140 }}>{isAr ? 'إجمالي المشتريات' : 'Total Purchases'}</th>
//                   <th className='small text-end py-3' style={{ minWidth: 140 }}>{isAr ? 'إجمالي المدفوعات' : 'Total Payments'}</th>
//                   <th className='small text-end py-3' style={{ minWidth: 140 }}>{isAr ? 'صافي الرصيد' : 'Net Balance'}</th>
//                   <th className='small py-3' style={{ minWidth: 120 }}>{isAr ? 'الحالة' : 'Status'}</th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {!loading && items.length > 0 ? (
//                   items.map((r, idx) => (
//                     <tr key={idx} className='align-middle'>
//                       <td className='text-start fw-bold text-primary'>{safe(r?.supplieR_NAME)}</td>
//                       <td className='text-center'>{safe(r.vaT_CODE)}</td>

//                       <td className='text-end fw-bold'>{formatNumber(r?.totaL_PURCHASES)}</td>
//                       <td className='text-end fw-bold text-success'>{formatNumber(r?.totaL_PAYMENTS_ADJUSTED)}</td>

//                       <td className={`text-end fw-bold ${Number(r?.neT_BALANCE) < 0 ? 'text-danger' : 'text-primary'}`} dir="ltr">
//                         {formatNumber(r?.neT_BALANCE)}
//                       </td>

//                       <td className='text-center'>
//                         <span className={`badge ${r.status?.includes('مستحق') ? 'bg-danger bg-opacity-10 text-danger border border-danger' : 'bg-secondary bg-opacity-10 text-secondary border border-secondary'}`}>
//                           {safe(r.status)}
//                         </span>
//                       </td>
//                     </tr>
//                   ))
//                 ) : !loading ? (
//                   <tr>
//                     <td colSpan={6} className='text-center py-5'>
//                       <div className='text-muted'>
//                         <i className='fas fa-users-cog fa-3x mb-3 opacity-50'></i>
//                         <h6>{t('NoData')}</h6>
//                       </div>
//                     </td>
//                   </tr>
//                 ) : null}
//               </tbody>
//             </table>
//           </div>
//         </Loading>

//         <CardFooter>
//           <div className='d-flex justify-content-between align-items-center flex-wrap gap-3'>
//             <ReportPagination reportKey={REPORT_KEY} maxVisiblePages={3} showItemsPerPage={true} />

//           </div>
//         </CardFooter>
//       </Card>

//       <ReportExportExcelModal
//         show={showExport}
//         onHide={() => setShowExport(false)}
//         reportKey={REPORT_KEY}
//         endpoint={ENDPOINT}
//         columns={exportColumns}
//         exportPageSize={4000}
//         sheetName={({ isAr }) => (isAr ? 'إجمالي أرصدة الموردين' : 'Suppliers Total Balances')}
//         fileName={({ reportKey }) => `${reportKey}_${new Date().toISOString().slice(0, 10)}.xlsx`}
//       />
//     </>
//   );
// };

// export default ApSuppliersTotalBalances_Paged;

import React, { useEffect, useState, useMemo } from 'react';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';

import Loading from '@components/Shared/Loader/Loading';
import { Card, CardFooter, CardHeader } from '@components/card/card';

import { useAppDispatch, useAppSelector } from '@store/hooks';
import { initReport, getReportPagedData, selectReport, setReportRequest } from '@store/DynamicSlice/reportTableSlice';

import ReportExportExcelModal, { type ExportColumn } from '@Helper/ReportPaged/ReportExportExcelModal';
import ReportPagination from '@Helper/ReportPaged/ReportPagination';

import useGetOperatingUnitWithPermission from '@hooks/NTX/Organization/useGetOperatingUnitWithPermission';
import useGetSuppliersList from '@hooks/NTX/Peoples/useGetSuppliersList';
import useLookup from '@hooks/Lookups/useLookup';

/** =========================
 * REQUEST SHAPE
 * ========================= */
type ApSuppliersTotalBalancesReq = {
  pageIndex?: number;
  pageSize?: number;
  aS_OF_DATE?: string | null;
  supplieR_ID?: string | null;
  organizatioN_ID?: string | null;
  peoplE_CATEGORY?: string | null; // <-- NEW FIELD
};

/** =========================
 * RESPONSE SHAPE (Array items)
 * ========================= */
type RowDto = {
  supplieR_NAME: string | null;
  vaT_CODE: string | null;
  totaL_PURCHASES: number | null;
  totaL_PAYMENTS_ADJUSTED: number | null;
  neT_BALANCE: number | null;
  status: string | null;
};

const REPORT_KEY = 'RPT_ApSuppliersTotalBalances';
const ENDPOINT = 'FinReports/GetApSuppliersTotalBalances';

const safe = (v: any, fallback = '—') => (v === null || v === undefined || v === '' ? fallback : String(v));

const formatNumber = (num: number | null | undefined, digits: number = 2) => {
  if (num === null || num === undefined) return '0.00';
  return new Intl.NumberFormat('en-US', { minimumFractionDigits: digits, maximumFractionDigits: digits }).format(
    num || 0
  );
};

const isoOrNull = (d: any) => {
  if (!d) return null;
  if (typeof d === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(d)) return `${d}T00:00:00.000Z`;
  if (d instanceof Date) return d.toISOString();
  return null;
};

const cleanNulls = <T extends Record<string, any>>(obj: T): Partial<T> => {
  const out: any = {};
  for (const [k, v] of Object.entries(obj)) {
    if (v === null || v === undefined || v === '') continue;
    out[k] = v;
  }
  return out;
};

const getOptId = (opt: any): string | null => {
  const v = opt?.value ?? opt?.id ?? opt?.ID ?? opt?.key ?? null;
  return v ? String(v) : null;
};

const ApSuppliersTotalBalances_Paged: React.FC = () => {
  const { t, i18n } = useTranslation();
  const isAr = i18n.language !== 'en';

  const dispatch = useAppDispatch();

  // ===== Options Hooks
  const branchHook = useGetOperatingUnitWithPermission() as any;
  const OptionsBranches = branchHook?.OperatingUnitOptions ?? branchHook?.OptionsBranches ?? [];
  const loadingBranches = branchHook?.loading ?? false;

  const suppHook = useGetSuppliersList() as any;
  const OptionsSuppliers = suppHook?.OptionSuppliers ?? suppHook?.OptionsSuppliers ?? suppHook?.options ?? [];
  const loadingSuppliers = suppHook?.loading ?? false;

  // ===== Category Options (يمكنك ربطها بـ API إذا كان لديك Hook مخصص)
  //   const categoryOptions = useMemo(
  //     () => [
  //       { value: null, label: isAr ? 'الكل' : 'All' },
  //       { value: 'Individual', label: isAr ? 'أفراد' : 'Individuals' },
  //       { value: 'Company', label: isAr ? 'شركات' : 'Companies' }
  //     ],
  //     [isAr]
  //   );

  const { optionsByType, loading: lookupLoading, error: lookupError } = useLookup(['SupplierCategory']);
  const categoryOptions = optionsByType.SupplierCategory;

  // ===== Filters State
  const [branchFilter, setBranchFilter] = useState<any>(null);
  const [supplierFilter, setSupplierFilter] = useState<any>(null);
  const [categoryFilter, setCategoryFilter] = useState<any>(categoryOptions[0]); // <-- NEW STATE
  const [asOfDate, setAsOfDate] = useState<any>(null);

  const [showExport, setShowExport] = useState(false);

  // ===== Report state
  const report = useAppSelector(s => selectReport(s as any, REPORT_KEY));
  const items = (report?.items ?? []) as RowDto[];
  const meta = report?.meta ?? null;
  const loading = report?.loading ?? false;
  const error = report?.error ?? null;

  useEffect(() => {
    const initialRequest: ApSuppliersTotalBalancesReq = {
      pageIndex: 0,
      pageSize: 50
    };

    dispatch(
      initReport({
        reportKey: REPORT_KEY,
        endpoint: ENDPOINT,
        initialRequest
      })
    );
  }, [dispatch]);

  const applyFilters = () => {
    const prevReq = (((report as any)?.request ?? {}) as ApSuppliersTotalBalancesReq) || {};

    const nextReq: ApSuppliersTotalBalancesReq = {
      ...prevReq,
      pageIndex: 0,
      pageSize: prevReq.pageSize ?? 50,
      aS_OF_DATE: isoOrNull(asOfDate),
      organizatioN_ID: getOptId(branchFilter),
      supplieR_ID: getOptId(supplierFilter),
      peoplE_CATEGORY: categoryFilter?.value ?? null // <-- NEW FIELD IN REQUEST
    };

    dispatch(setReportRequest({ reportKey: REPORT_KEY, request: cleanNulls(nextReq) as any }));
    dispatch(getReportPagedData({ reportKey: REPORT_KEY }));
  };

  const clearFilters = () => {
    setBranchFilter(null);
    setSupplierFilter(null);
    setCategoryFilter(categoryOptions[0]); // <-- RESET NEW FIELD
    setAsOfDate(null);

    const resetReq: ApSuppliersTotalBalancesReq = {
      pageIndex: 0,
      pageSize: 50
    };

    dispatch(setReportRequest({ reportKey: REPORT_KEY, request: resetReq as any }));
    dispatch(getReportPagedData({ reportKey: REPORT_KEY })); // Added to fetch default data after clearing
  };

  // Totals Cards
  const TotalsCards = () => {
    if (!meta) return null;

    return (
      <div className='row g-3 mb-4'>
        {/* إجمالي المشتريات */}
        <div className='col-lg-4 col-md-6'>
          <Card className='bg-primary bg-opacity-10 border-0 shadow-sm h-100'>
            <div className='card-body d-flex align-items-center'>
              <div className='p-3 me-3'>
                <i className='fas fa-shopping-cart text-primary fa-xl'></i>
              </div>
              <div>
                <h6 className='text-primary fw-bold mb-1'>{isAr ? 'إجمالي المشتريات' : 'Grand Purchases'}</h6>
                <h4 className='mb-0 fw-bold'>{formatNumber(meta.granD_PURCHASES)}</h4>
              </div>
            </div>
          </Card>
        </div>

        {/* إجمالي المدفوعات */}
        <div className='col-lg-4 col-md-6'>
          <Card className='bg-success bg-opacity-10 border-0 shadow-sm h-100'>
            <div className='card-body d-flex align-items-center'>
              <div className='p-3 me-3'>
                <i className='fas fa-money-check-alt text-success fa-xl'></i>
              </div>
              <div>
                <h6 className='text-success fw-bold mb-1'>{isAr ? 'إجمالي المدفوعات' : 'Grand Payments'}</h6>
                <h4 className='mb-0 fw-bold'>{formatNumber(meta.granD_PAYMENTS)}</h4>
              </div>
            </div>
          </Card>
        </div>

        {/* إجمالي المديونية المستحقة */}
        <div className='col-lg-4 col-md-6'>
          <Card className='bg-danger bg-opacity-10 border-0 shadow-sm h-100'>
            <div className='card-body d-flex align-items-center'>
              <div className='p-3 me-3'>
                <i className='fas fa-file-invoice-dollar text-danger fa-xl'></i>
              </div>
              <div>
                <h6 className='text-danger fw-bold mb-1'>
                  {isAr ? 'إجمالي المديونية المستحقة' : 'Total Outstanding Debt'}
                </h6>
                <h4 className='mb-0 fw-bold'>{formatNumber(meta.totaL_OUTSTANDING_DEBT)}</h4>
              </div>
            </div>
          </Card>
        </div>
      </div>
    );
  };

  const exportColumns: ExportColumn<RowDto>[] = [
    { headerAr: 'المورد', headerEn: 'Supplier Name', value: r => r.supplieR_NAME || '' },
    { headerAr: 'الرقم الضريبي', headerEn: 'VAT Code', value: r => r.vaT_CODE || '' },
    { headerAr: 'إجمالي المشتريات', headerEn: 'Total Purchases', value: r => r.totaL_PURCHASES || 0 },
    { headerAr: 'إجمالي المدفوعات', headerEn: 'Total Payments', value: r => r.totaL_PAYMENTS_ADJUSTED || 0 },
    { headerAr: 'صافي الرصيد', headerEn: 'Net Balance', value: r => r.neT_BALANCE || 0 },
    { headerAr: 'الحالة', headerEn: 'Status', value: r => r.status || '' }
  ];

  return (
    <>
      <CardHeader className='mb-3'>
        <div className='row g-2 align-items-center mb-2'>
          {/* Branch */}
          <div className='col-lg-2'>
            <div className='input-group'>
              <span className='input-group-text fw-bold' title={isAr ? 'الفرع' : 'Branch'}>
                <i className='fas fa-store text-primary'></i>
              </span>
              <Select
                isLoading={loadingBranches}
                value={branchFilter}
                onChange={setBranchFilter}
                options={OptionsBranches}
                placeholder={isAr ? 'الفرع' : 'Branch'}
                isClearable
                isSearchable
                className='flex-grow-1'
                classNamePrefix='react-select'
                menuPortalTarget={document.body}
                styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
              />
            </div>
          </div>

          {/* Category (الفئة) */}
          <div className='col-lg-2'>
            <div className='input-group'>
              <span className='input-group-text fw-bold' title={isAr ? 'الفئة' : 'Category'}>
                <i className='fas fa-tags text-warning'></i>
              </span>
              <Select
                value={categoryFilter}
                onChange={setCategoryFilter}
                options={categoryOptions}
                placeholder={isAr ? 'الفئة' : 'Category'}
                isClearable
                isSearchable
                className='flex-grow-1'
                classNamePrefix='react-select'
                menuPortalTarget={document.body}
                styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
              />
            </div>
          </div>

          {/* Supplier */}
          <div className='col-lg-3'>
            <div className='input-group'>
              <span className='input-group-text fw-bold' title={isAr ? 'المورد' : 'Supplier'}>
                <i className='fas fa-truck text-info'></i>
              </span>
              <Select
                isLoading={loadingSuppliers}
                value={supplierFilter}
                onChange={setSupplierFilter}
                options={OptionsSuppliers}
                placeholder={isAr ? 'المورد' : 'Supplier'}
                isClearable
                isSearchable
                className='flex-grow-1'
                classNamePrefix='react-select'
                menuPortalTarget={document.body}
                styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
              />
            </div>
          </div>

          {/* As of Date */}
          <div className='col-lg-2'>
            <div className='input-group'>
              <span className='input-group-text fw-bold' title={isAr ? 'حتى تاريخ' : 'As Of Date'}>
                <i className='fas fa-calendar'></i>
              </span>
              <input
                type='date'
                className='form-control'
                value={asOfDate || ''}
                onChange={e => setAsOfDate(e.target.value)}
                placeholder={isAr ? 'حتى تاريخ' : 'As Of Date'}
              />
            </div>
          </div>

          {/* Buttons */}
          <div className='col-lg-3 text-end'>
            <button
              className='btn btn-outline-secondary me-2'
              type='button'
              onClick={clearFilters}
              title={t('ClearFilters')}
            >
              <i className='fas fa-times fa-fw'></i>
            </button>
            <button className='btn btn-theme me-2' type='button' onClick={applyFilters} title={t('ApplyFilters')}>
              <i className='fas fa-filter fa-fw'></i>
            </button>
            <button
              className='btn btn-outline-success'
              type='button'
              onClick={() => setShowExport(true)}
              title={t('Export')}
              disabled={loading || items.length === 0}
            >
              <i className='fas fa-file-excel fa-fw'></i>
            </button>
          </div>
        </div>
      </CardHeader>

      <TotalsCards />

      <Card className='mb-4'>
        <Loading loading={loading} error={error}>
          <div className='table-responsive' style={{ maxHeight: 'calc(100vh - 300px)', overflowY: 'auto' }}>
            <table className='table table-hover table-bordered mb-0'>
              <thead className='sticky-top align-middle' style={{ top: 0, zIndex: 10 }}>
                <tr className='bg-theme bg-opacity-25 text-center' style={{ backdropFilter: 'blur(20px)' }}>
                  <th className='small py-3' style={{ minWidth: 250 }}>
                    {isAr ? 'المورد' : 'Supplier'}
                  </th>
                  <th className='small py-3' style={{ minWidth: 150 }}>
                    {isAr ? 'الرقم الضريبي' : 'VAT Code'}
                  </th>
                  <th className='small text-end py-3' style={{ minWidth: 140 }}>
                    {isAr ? 'إجمالي المشتريات' : 'Total Purchases'}
                  </th>
                  <th className='small text-end py-3' style={{ minWidth: 140 }}>
                    {isAr ? 'إجمالي المدفوعات' : 'Total Payments'}
                  </th>
                  <th className='small text-end py-3' style={{ minWidth: 140 }}>
                    {isAr ? 'صافي الرصيد' : 'Net Balance'}
                  </th>
                  <th className='small py-3' style={{ minWidth: 120 }}>
                    {isAr ? 'الحالة' : 'Status'}
                  </th>
                </tr>
              </thead>

              <tbody>
                {!loading && items.length > 0 ? (
                  items.map((r, idx) => (
                    <tr key={idx} className='align-middle'>
                      <td className='text-start fw-bold text-primary'>{safe(r?.supplieR_NAME)}</td>
                      <td className='text-center'>{safe(r.vaT_CODE)}</td>

                      <td className='text-end fw-bold'>{formatNumber(r?.totaL_PURCHASES)}</td>
                      <td className='text-end fw-bold text-success'>{formatNumber(r?.totaL_PAYMENTS_ADJUSTED)}</td>

                      <td
                        className={`text-end fw-bold ${Number(r?.neT_BALANCE) < 0 ? 'text-danger' : 'text-primary'}`}
                        dir='ltr'
                      >
                        {formatNumber(r?.neT_BALANCE)}
                      </td>

                      <td className='text-center'>
                        <span
                          className={`badge ${r.status?.includes('مستحق') ? 'bg-danger bg-opacity-10 text-danger border border-danger' : 'bg-secondary bg-opacity-10 text-secondary border border-secondary'}`}
                        >
                          {safe(r.status)}
                        </span>
                      </td>
                    </tr>
                  ))
                ) : !loading ? (
                  <tr>
                    <td colSpan={6} className='text-center py-5'>
                      <div className='text-muted'>
                        <i className='fas fa-users-cog fa-3x mb-3 opacity-50'></i>
                        <h6>{t('NoData')}</h6>
                      </div>
                    </td>
                  </tr>
                ) : null}
              </tbody>
            </table>
          </div>
        </Loading>

        <CardFooter>
          <div className='d-flex justify-content-between align-items-center flex-wrap gap-3'>
            <ReportPagination reportKey={REPORT_KEY} maxVisiblePages={3} showItemsPerPage={true} />
          </div>
        </CardFooter>
      </Card>

      <ReportExportExcelModal
        show={showExport}
        onHide={() => setShowExport(false)}
        reportKey={REPORT_KEY}
        endpoint={ENDPOINT}
        columns={exportColumns}
        exportPageSize={4000}
        sheetName={({ isAr }) => (isAr ? 'إجمالي أرصدة الموردين' : 'Suppliers Total Balances')}
        fileName={({ reportKey }) => `${reportKey}_${new Date().toISOString().slice(0, 10)}.xlsx`}
      />
    </>
  );
};

export default ApSuppliersTotalBalances_Paged;
